<template>
    <div>
        <b-container>
            <h4 class="pt-5 pb-4 fw-600"> 답변 확인할 기업 선택 </h4>
            <b-row class="mb-5 bgray-200 py-3">
                <b-col cols="0" md="2" lg="3"></b-col>
                <b-col cols="12" md="8" lg="6">
                    <b-input-group>
                        <b-form-input v-model="search_keyword" placeholder="검색할 기업명 입력"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="icon-append">
                                <fa icon="search"></fa>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col cols="0" md="2" lg="3"></b-col>
            </b-row>

            <h5 class="pt-4 pb-2 border-bottom border-color-gray-300">
                참여 기업 ({{ filtered_companies.length }} 개사)
            </h5>
            <b-button v-for="(item, index) in filtered_companies"
                      :key="`company-${item.company_id}-${index}`"
                      variant="dark-border"
                      class="mr-2 mb-3 py-1 px-2"
                      @click="selectCompany(item)"
            >
                {{ item.company_name }}
            </b-button>
            <hr class="border-0 bottom-space">
        </b-container>
    </div>
</template>

<script>
import {mapState} from 'vuex';


export default {
    name: 'Answers',
    data() {
        return {
            search_keyword: '',
        };
    },
    computed: {
        ...mapState(['admin_mode', 'is_admin']),
        ...mapState('score', ['temp_target_companies']),
        filtered_companies() {
            let target_companies = this.temp_target_companies.filter(x => x.status_code !== 'canceled');
            if (this.search_keyword === '') {
                return target_companies;
            } else {
                let return_array = [];
                return_array = target_companies.filter(item => item.company_name.includes(this.search_keyword));
                return return_array;
            }
        },
    },
    methods: {
        async selectCompany(target_company) {
            const {template_code, project_code, campaign_id, company_id, company_name} = target_company;
            const {client,campaign_name} = this.$route.query;
            
            if(this.admin_mode === 'project'){
                this.$router.push({
                    name: 'CompanyAnswers',
                    params: {company_id},
                    query: {client, cpn: company_id, cmp: campaign_id, pc: project_code, cpnm: company_name, template_code, admin_mode: this.admin_mode}
                });
            }
            if(this.admin_mode === 'camp'){
                this.$router.push({
                    name: 'CompanyAnswers',
                    params: {company_id},
                    query: {campaign_name, cpn: company_id, cmp: campaign_id, pc: project_code, cpnm: company_name, template_code, admin_mode: this.admin_mode}
                });
            }

            
        },
    }
};
</script>
